/* ============
 * Client Type Transformer
 * ============
 *
 * The transformer for the clientType.
 */

import Transformer from './transformer';

export default class ClientTypeTransformer extends Transformer {
  static fetch(clientType) {
    return {
      id: clientType.id,
      name: clientType.name,
      exciseAdditionalCode: clientType.excise_additional_code,
    };
  }

  static send(clientType) {
    return {
      id: clientType.id,
      name: clientType.name,
      excise_additional_code: clientType.exciseAdditionalCode,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/clientType.js